'use client';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { HiChevronDown } from 'react-icons/hi';

import { useTranslation } from 'src/i18n/client';

export default function CNPDisclosure() {
    const { t } = useTranslation(null, 'common');

    return (
        <Disclosure as="div" className="rounded-xs bg-white/75 p-4 text-left text-sm">
            <DisclosureButton className="group flex w-full items-center justify-between gap-4">
                <span className="text-left">{t('bulletinResults.cnpDisclosureTitle')}</span>{' '}
                <HiChevronDown className="text-2xl group-data-open:rotate-180" aria-hidden />
            </DisclosureButton>
            <DisclosurePanel className="mt-4 opacity-75">
                {t('bulletinResults.cnpDisclosureDescription')}
            </DisclosurePanel>
        </Disclosure>
    );
}
